<template>
  <div class="page-outbox" v-if="orderInfo.so_no">
    <!--订单号 订单状态-->
    <div class="order-status">
      <label>订单号：{{orderInfo.so_no}}</label>
      <span>{{orderStatusMap[orderInfo.so_review_status]}}/{{orderTypeMap[orderInfo.so_pay_status]}}</span>
    </div>
    <!--订单时间-->
    <div class="order-time">
      <label>订单时间：{{orderInfo.so_ctime}}</label>
    </div>
    <!--地址-->
    <div class="order-addr">
      <h3 class="block-title">收货地址</h3>
      <h3 class="addr-user"><label class="name">{{orderInfo.so_ca_name}}</label><span class="telNum">{{orderInfo.so_ca_mobile}}</span><span class="telNum">&nbsp;&nbsp;{{orderInfo.so_ca_phone}}</span></h3>
      <p class="addr-area">
        <span class="area">{{orderInfo.so_ca_province}}</span><span class="area">{{orderInfo.so_ca_city}}</span>
        <span class="area">{{orderInfo.so_ca_county}}</span><span class="area">{{orderInfo.so_ca_street}}</span>
      </p>
    </div>
    <!--收票信息-->
    <div class="order-invoice">
      <h3 class="block-title">收票信息</h3>
      <p class="invoice-company">{{orderInfo.so_cia_name}} &nbsp;&nbsp; {{orderInfo.so_cia_mobile}}&nbsp;&nbsp; {{orderInfo.so_cia_phone}}</p>
      <p class="addr-area">
        <span class="area">{{orderInfo.so_cia_province}}</span><span class="area">{{orderInfo.so_cia_city}}</span>
        <span class="area">{{orderInfo.so_cia_county}}</span><span class="area">{{orderInfo.so_cia_street}}</span>
      </p>
    </div>
    <!--发票信息-->
    <div class="order-invoice">
      <h3 class="block-title">发票信息</h3>
      <div class="invoice-company invoice-info-item" v-if="orderInfo.so_ci_method==3">不开发票</div>
      <template v-else>
        <p class="invoice-company invoice-info-item" style="line-height: .2rem;">{{orderInfo.so_ci_title}} <br/>  {{orderInfo.so_ci_vatno}}</p>
        <template v-if="orderInfo.so_ci_type==2">
          <p class="invoice-info-item"><label>开户行:</label><span>{{orderInfo.so_ci_bank}}</span></p>
          <p class="invoice-info-item"><label>银行账号:</label><span>{{orderInfo.so_ci_bknum}}</span></p>
          <p class="invoice-info-item"><label>开票电话:</label><span>{{orderInfo.so_ci_phone}}</span></p>
          <p class="invoice-info-item"><label>开票方式:</label><span>{{invoiceTypeMap[orderInfo.so_ci_method]}}</span></p>
          <p class="addr-area">
            <span class="area">{{orderInfo.so_ci_addr}}</span>
          </p>
        </template>
      </template>


    </div>
    <!--订单列表-->
    <div class="goods-list-box">
      <h3 class="block-title">商品信息</h3>
      <ul class="goods-list" v-if="orderInfo.soitems&&orderInfo.soitems.length">
        <li class="goods-list-item" v-for="(item,index) in orderInfo.soitems" @click="toDetail(item)">
          <order-item :goodsData="item" :readOnly="true" :isDetailItem="true"></order-item>
        </li>
      </ul>
    </div>
    <!--订单价格-->
    <div class="order-price">
      <div style="float: left;">
        <label>运费：</label>
        <span>￥{{orderInfo.express}}</span>
      </div>
      <label>总计：</label>
      <span>￥{{orderInfo.so_total}}</span>
    </div>
  </div>
</template>

<script>
  import OrderItem from 'basic/orderItem/orderItem'
  export default {
    name: "orderDetail",
    data(){
      return{
        orderInfo:{},
        orderStatusMap:['未审核','审核通过','审核通过','已取消'],
        orderTypeMap: [ '未付款','部分付款','全额付款'],
        invoiceTypeMap:['随货','月开','半月开','不开票']
      }
    },
    mounted(){
      this.getOrderDetail();
    },
    methods:{
      toDetail(item){
        this.$router.push({path:'/GoodsDetail/'+item.id})
      },
      getOrderDetail(){
        this.$cHttp.post('orders/detail',{
          partner:this.$systemConfig.partner,
          apikey:this.$systemConfig.apikey,
          user_id:this.$store.state.userInfo.user_id,
          so_id:this.$route.params.orderId,
        }).then((res)=>{
          console.log(res)
          if(res.status&&res.status==1){
            this.orderInfo=res.data;
          }else{
            this.$toast('暂无数据')
          }
        }).catch((msg)=>{
          this.$toast(msg);
        })
      }
    },
    components:{
      OrderItem
    }
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss" scoped>
  .page-outbox{
    background-color: #eee;
  }
  .order-status{
    display: flex;
    padding: .15rem .1rem;
    margin-bottom: .01rem;
    font-size: .13rem;
    background-color: #fff;
    >label{
      color: #333;
    }
    >span{
      flex: 1;
      text-align: right;
      color:#0b8ef1;
    }
  }
  .order-time{
    display: flex;
    padding: .15rem .1rem;
    margin-bottom: .01rem;
    font-size: .13rem;
    background-color: #fff;
    >label{
      color: #333;
    }
  }
  .order-addr{
    padding: .1rem;
    margin-bottom: .01rem;
    background-color: #fff;
    .addr-user{
      font-size: .14rem;
      color: #333;
      line-height: .25rem;
      >label{
        padding-right: .1rem;
      }
    }
    .addr-area{
      font-size: .13rem;
      color: #999;
      line-height: .2rem;
      .area{
        padding-right: .04rem;
      }
    }
  }
  .order-invoice{
    padding: .1rem;
    margin-bottom: .01rem;
    background-color: #fff;
    .invoice-company,.invoice-info-item {
      font-size: .14rem;
      color: #333;
      line-height: .25rem;
      > label {
        padding-right: .1rem;
      }
    }
    .addr-area{
      font-size: .13rem;
      color: #999;
      line-height: .2rem;
      .area{
        padding-right: .04rem;
      }
    }
  }
  .block-title{
    padding-bottom:.05rem;
    font-size: .14rem;
    line-height: .14rem;
    color: $mainColor;
    opacity: .3;
    &:before{
      content: "";
      display: inline-block;
      vertical-align: bottom;
      margin-right: .05rem;
      width: 3px;
      height: .14rem;
      background-color: $mainColor;
    }
  }
  .goods-list-box{
    margin-bottom: .01rem;
    background-color: #fff;
    .block-title{
      padding: .12rem .1rem 0;
    }
    .goods-list-item{
      border-bottom: 1px dashed #eee;
    }
  }
  .order-price{
    padding: .15rem .1rem;
    text-align: right;
    font-size: .14rem;
    color: #333;
    >span{
      font-size: .16rem;
      font-weight: bold;
      color: $mainColor;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/orderDetail/orderDetail.vue